module.exports = __webpack_public_path__ + "static/img/产后连体衣.6f3b61e7.jpg";